import { ALL_TIME_RANGE_QUERY } from 'consts/filterOptions'
import { SparklineIntervalTimeUnitEnum } from 'generated/graphql'
import { getCustomTimeUnitByDays, getTimeRange } from 'utils'
import { getCustomTimeDifference } from 'utils/getCustomTimeDifference'
import getUploadDateByValue from 'utils/getUploadDateByValue'
import { getFormatedDateVariablesForTerritory } from 'utils/territoryUtils'

import { DAY_INTERVALS } from './territory.consts'

export const getRelevanceInterval = (uploadDate: string) => {
  if (!uploadDate) {
    return SparklineIntervalTimeUnitEnum.Day
  }
  if (uploadDate.includes('custom')) {
    const difference = getCustomTimeDifference(uploadDate)
    const timeUnit = getCustomTimeUnitByDays(difference)
    return timeUnit as SparklineIntervalTimeUnitEnum
  }

  if (DAY_INTERVALS.includes(uploadDate)) {
    return SparklineIntervalTimeUnitEnum.Day
  }
  return SparklineIntervalTimeUnitEnum.Month
}

export const getTimeVariables = (uploadDate: string) => {
  const isToday = uploadDate === '24h'
  const isCustomDate = uploadDate?.includes('custom')
  const isAllTime = uploadDate === 'all'
  const shouldUseTimeRange = !isCustomDate && !isAllTime

  const publishedAtValue = isCustomDate ? getUploadDateByValue(uploadDate) : ALL_TIME_RANGE_QUERY
  const dateValue = getFormatedDateVariablesForTerritory(uploadDate)

  const timeRange = isToday ? getTimeRange('day', 7) : dateValue

  return shouldUseTimeRange
    ? {
        timeRange,
      }
    : {
        publishedAt: publishedAtValue,
        timeRange: null,
      }
}
